module.exports = __webpack_public_path__ + "img/zain-ksa.fc8d5c88.svg";